import React from "react";

/**
 * Film grain overlay using inline SVG turbulence.
 *
 * @param {number} opacity   - 0..1, overall layer opacity.
 * @param {string} blend     - mix-blend-mode (overlay / soft-light / normal / screen).
 * @param {number} scale     - tile size in px, smaller = denser grain (default 220).
 * @param {number} freq      - feTurbulence baseFrequency (default 1.1, higher = finer).
 * @param {number} alpha     - per-particle alpha 0..1 (default 0.75).
 */
export default function GrainOverlay({
  opacity = 0.22,
  blend = "overlay",
  scale = 220,
  freq = 1.1,
  alpha = 0.75,
}) {
  const svg =
    `<svg xmlns='http://www.w3.org/2000/svg' width='${scale}' height='${scale}'>` +
    `<filter id='n'>` +
    `<feTurbulence type='fractalNoise' baseFrequency='${freq}' numOctaves='2' stitchTiles='stitch'/>` +
    `<feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 ${alpha} 0'/>` +
    `</filter>` +
    `<rect width='100%' height='100%' filter='url(%23n)'/></svg>`;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        opacity,
        mixBlendMode: blend,
        backgroundImage: `url("data:image/svg+xml;utf8,${svg}")`,
        backgroundSize: `${scale}px ${scale}px`,
      }}
    />
  );
}
